/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';
import { WORKER_FORK_EXECUTION_FRAGMENT } from '../fragments/worker';

export const ON_WORKER_SENTENCE_UPDATE = gql`
  subscription onWorkerSentenceUpdate($workerId: ID!, $documentToken: String) {
    onSentenceUpdate(workerId: $workerId, documentToken: $documentToken) {
      sentences {
        answer
        concepts
        epoch
        iterationTokens
        lineId
        requests
        status
        token
        epoch
        subDocuments {
          documentToken
          processName
        }
        miniPlaygrounds {
          documentToken
          processName
        }
        startedAt
        completedAt
      }
    }
  }
`;

export const ON_SENTENCE_MINI_PLAYGROUNDS_UPDATE = gql`
  subscription onMiniPGSentenceUpdate($workerId: ID!, $documentToken: String) {
    onSentenceUpdate(workerId: $workerId, documentToken: $documentToken) {
      sentences {
        lineId
        token
        miniPlaygrounds {
          documentToken
          processName
        }
      }
    }
  }
`;

export const ON_WORKER_UPDATE = gql`
  ${WORKER_FORK_EXECUTION_FRAGMENT}
  subscription OnWorkerUpdate($id: ID!) {
    onNotifyWorkerUpdate(id: $id) {
      id
      owner
      readers
      editors
      name
      description
      version
      departmentVersion
      knowledgeId
      departmentId
      procedureId
      entryCommand
      entryCommandId
      originalWorkerId
      createdAt
      state
      stage
      stateLastUpdatedAt
      attachments
      isArchived
      features
      replayWorkerId
      ...WorkerForkExecutionInfo
    }
  }
`;

export const ON_WORKER_STATE_UPDATE = gql`
  subscription OnWorkerStateUpdate($id: ID, $procedureId: ID) {
    onNotifyWorkerUpdate(id: $id, procedureId: $procedureId) {
      id
      state
    }
  }
`;

export const ON_WORKER_DOCUMENT_UPDATE = gql`
  subscription OnWorkerDocumentUpdate($workerId: ID!) {
    onWorkerDocumentUpdate(workerId: $workerId) {
      sentences {
        text
        parentId
        language
        lineId
        metadata {
          lineId
          parentId
        }
        internalMetadata {
          key
          value
        }
      }
      updatedAt
    }
  }
`;

export const ON_WORKER_STATUS = gql`
  subscription OnWorkerStatus($id: ID!) {
    onWorkerStatus(id: $id) {
      id
      mood
      operation
      icons
      what
    }
  }
`;
